// AbortSignal.any is newer than the site's supported browsers.
export function combineRequestSignals(
  ...signals: [AbortSignal, ...AbortSignal[]]
): AbortSignal {
  const controller = new AbortController();
  const subscriptions = signals.map((source) => ({
    source,
    listener: () => controller.abort(source.reason),
  }));
  controller.signal.addEventListener(
    "abort",
    () => {
      for (const { source, listener } of subscriptions)
        source.removeEventListener("abort", listener);
    },
    { once: true },
  );

  for (const { source, listener } of subscriptions) {
    if (source.aborted) {
      controller.abort(source.reason);
      break;
    }

    source.addEventListener("abort", listener, { once: true });
  }

  return controller.signal;
}

export function withRequestDeadline(
  signal: AbortSignal | undefined,
  timeoutMs: number,
): AbortSignal {
  const deadline = AbortSignal.timeout(timeoutMs);
  return signal ? combineRequestSignals(signal, deadline) : deadline;
}
